import React, { useState, useEffect } from 'react';

import LoadingBox from "@components/input/LoadingBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";

import { DisablableOption, ModelBase } from "@models";

import DandDAPI from "@dndUtilities/system_api";
import { DataType } from '@dndModels/Types';


interface Props {
  data_type: DataType;
  field: string;
  any_for_base?: boolean;
  filter?: any;
  value?: string;
  values?: string[];
  extra_options?: string[];
  multiple?: boolean;
  name: string;
  onChange?: Function | null;
  onClose?: Function | null;
  color?: string;
  disabled?: boolean;
}

const api = DandDAPI.getInstance();

export default function SelectObjectFieldBox({ 
  data_type,
  field,
  any_for_base = false,
  name,
  multiple = false,
  value,
  values = [],
  color = "",
  extra_options = [],
  filter = {},
  disabled = false,
  onChange = null,
  onClose = null }: Props) {
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [field_values, setFieldValues] = useState<DisablableOption[]>([]);
  const [any_for_bases, setAnyForBases] = useState<DisablableOption[]>([]);

  // passing an empty array as second argument triggers the callback in useEffect
  // only after the initial render thus replicating `componentDidMount` lifecycle behaviour
  useEffect(() => {
    if(!fetched) {
      load();
    }
  });

  const isValid = (data: any) => {
    if (data === null || data === undefined) {
      return false;
    } else {
      const the_type = typeof(data);
      if (the_type === "object") {
        if (data.length !== undefined) {
          if (data.length === 0) {
            return false;
          }
        }
      } else if (the_type === "string") {
        if (data === "") {
          return false;
        }
      }
    }
    return true;
  }

  const load = () => {
    // debugger;
    setFetched(true);
    setLoading(true);
    api.getObjectFieldValues(data_type, field, filter).then(res => {
      // debugger;
      setFieldValues((res as string[]).filter(o => o !== "").map(o => { 
        const option: DisablableOption = {
          id: o, text: o, disabled: false, reason: ""
        };
        return option;
      }));
      if (any_for_base) {
        api.getObjects({ data_type, filter}).then(res2 => {
          const new_anys = res2 as any[];
          const new_objects = new_anys.filter((o: any) => isValid(o[field])) as ModelBase[];
          const new_options: DisablableOption[] = new_objects.map(o => {
            const option: DisablableOption = {
              id: `Any for ${o._id}`, text: `Any for ${o.use_name}`, disabled: false, reason: ""
            };
            return option;
          });
          setAnyForBases(new_options);
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    });
  }

  const renderControl = () => {
    return (
      <SelectStringBox 
        name={name}
        value={value}
        values={values}
        options={field_values}
        extra_options={[...extra_options,...any_for_bases]}
        multiple={multiple}
        disabled={disabled}
        onChange={onChange}
        onClose={onClose}
      />
    );
  }

  if (field === "") {
    return <span></span>;
  } else if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    if (color !== "") {
      return (
        <div style={{
          border: "1px solid #1C9AEF"
        }}>
          { renderControl() }
        </div>
      );
    } else {
      return renderControl();
    }
  }
}
